import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

import Usuarios from '@/views/Usuarios.vue'
import Empresas from '@/views/Empresas.vue'

import Grupos from '@/views/Grupos.vue'
import Subgrupos from '@/views/Subgrupos.vue'

import Funcoes from '@/views/Funcoes.vue'
import Colaborador from '@/views/Colaborador.vue'
import Jornadas from '@/views/Jornadas.vue'

import RegistrosDePonto from '@/views/RegistrosDePonto.vue'
import RelespelhoPonto from '@/views/relatorios/RelespelhoPonto.vue'
import Justificativas from '@/views/justificativas.vue'

import ExportarRegistros from '@/views/ExportarRegistros.vue'
import Zonas from '@/views/Zonas.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

  {
    path: '/Usuarios',
    name: 'Usuarios',
    component: Usuarios
  },
  {
    path: '/Empresas',
    name: 'Empresas',
    component: Empresas
  },

  {
    path: '/grupos',
    name: 'Grupos',
    component: Grupos
  },
  {
    path: '/subgrupos',
    name: 'Subgrupos',
    component: Subgrupos
  },

  {
    path: '/funcoes',
    name: 'Funcoes',
    component: Funcoes
  },

  {
    path: '/colaboradores',
    name: 'Colaborador',
    component: Colaborador
  },

  {
    path: '/jornadas',
    name: 'Jornadas',
    component: Jornadas
  },

  {
    path: '/registrosdeponto',
    name: 'RegistrosDePonto',
    component: RegistrosDePonto
  },

  {
    path: '/relespelhoponto',
    name: 'RelespelhoPonto',
    component: RelespelhoPonto
  },

  {
    path: '/justificativas',
    name: 'Justificativas',
    component: Justificativas
  },

  {
    path: '/exportar',
    name: 'Exportarregistros',
    component: ExportarRegistros
  },

  {
    path: '/zonas',
    name: 'Zonas',
    component: Zonas
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
